import { format, unwrapFunctionStore } from 'svelte-i18n';

const $format = unwrapFunctionStore(format);

export const exporting = {
  element: '#export-dropdown > ul',
  popover: {
    title: 'Exporting Campaigns',
    description:
      'Need campaign data? Click the <code><i class="os-icon-download"></i></code> button to open the export menu and download your campaigns as a CSV file!',
    side: 'left',
    align: 'center'
  }
};
